import { getBscGlobalState } from '../../../common/utils';
import { LEGACY_ATLASSIAN_GDPR_COOKIE_KEY } from '../../../constants';
import { PreferenceCategory } from '../../../types';
import { setConsentToken } from '../../cookie-controls/set-consent-token';
import { setStrictlyNecessaryCookie } from '../../cookie-controls/set-strictly-necessary-cookie';
import { packUserPreferences } from '../../cookie-controls/transformer';
const emptyDisplayedTextMap = {
  [PreferenceCategory.Analytics]: '',
  [PreferenceCategory.Functional]: '',
  [PreferenceCategory.Marketing]: '',
  [PreferenceCategory.StrictlyNecessary]: '',
  [PreferenceCategory.Unknown]: ''
};
export async function updatePreferences(preferences, displayedTextMap = emptyDisplayedTextMap, usingPrefetchedData) {
  if (getBscGlobalState().localConsentMode) {
    const packedPrefs = packUserPreferences(preferences);
    setStrictlyNecessaryCookie(LEGACY_ATLASSIAN_GDPR_COOKIE_KEY, packedPrefs, {
      expires: 365,
      path: '/'
    });
  } else {
    await setConsentToken(preferences, displayedTextMap, usingPrefetchedData);
  }
}